import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { PensionFormFields } from "web_myplann/Portfolio/Forms/PensionForm/PensionFormFields";
import { useEditPensionForm } from "web_myplann/Portfolio/Forms/PensionForm/useEditPensionForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

type EditPensionFormProps = {
	portfolioId: number;
	portfolio: PortfolioDetailResponseDTO;
	detailRoute: string;
};

export const EditPensionForm = ({
	portfolioId,
	portfolio,
	detailRoute,
}: EditPensionFormProps) => {
	const { t } = useResource();
	const { form, onSubmit, isPending, leaveConfirmation } = useEditPensionForm({
		portfolioId,
		portfolio,
		detailRoute,
	});

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.EditPortfolio.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
			leaveConfirmation={leaveConfirmation}
		>
			<PensionFormFields
				control={form.control}
				productCategory={portfolio.productCategory}
			/>
		</PortfolioFormShell>
	);
};
